import init from '../../../js/init';

const name = 'header';
const selector = '.header';
const openClass = `${selector}--open`.substring(1);
const hiddenClass = `hidden`;
const searchActiveClass = `${selector}--search-active`.substring(1);
const hamburgerSelector = `${selector}__hamburger`;
const menusSelector = `${selector}__menu`;
const bodySelector = `${selector}__body`;
const searchBtnSelector = `${selector}__search-btn`;
const searchInputSelector = `${selector}__search-form input`;

init(Drupal, name, selector, root => {
  let isOpen = false;
  const hamburger = root.querySelector(hamburgerSelector);
  const menus = root.querySelector(menusSelector);
  const body = root.querySelector(bodySelector);
  const searchBtn = root.querySelector(searchBtnSelector);
  const searchInput = root.querySelector(searchInputSelector);
  body.style.display = 'block';

  const toggleMenu = () => {
    root.classList.toggle(openClass);
    menus.classList.toggle(hiddenClass);
    body.style.display = body.style.display === 'block' ? 'flex' : 'block';
    isOpen = !isOpen;
  };

  const searchBtnClick = () => {
    root.classList.add(searchActiveClass);
    searchInput.focus();
  };

  const searchInputBlur = () => {
    root.classList.remove(searchActiveClass);
  };

  if (hamburger) hamburger.onclick = toggleMenu;
  if (searchBtn) searchBtn.onclick = searchBtnClick;
  if (searchInput) searchInput.onblur = searchInputBlur;
});
